import { render, staticRenderFns } from "./AddMember.vue?vue&type=template&id=0f22fbc0"
import script from "./AddMember.vue?vue&type=script&lang=js"
export * from "./AddMember.vue?vue&type=script&lang=js"
import style0 from "./AddMember.vue?vue&type=style&index=0&id=0f22fbc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports